import { API_CONFIG } from '../config/api';

interface UserAdmin {
  id: number;
  name: string;
  email: string;
  created_date: string;
  updated_date: string;
}

interface UserAdminListResponse {
  content: UserAdmin[];
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}

interface CreateUserAdminRequest {
  name: string;
  email: string;
  password: string;
}

interface UpdateUserAdminRequest {
  name: string;
  email: string;
  password?: string; // opcional na atualização
}

const getHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
});

export const userAdminService = {
  async listUserAdmins(page: number = 1, perPage: number = 10): Promise<UserAdminListResponse> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}/user-admins?page=${page}&per_page=${perPage}`,
        {
          headers: getHeaders(),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch user admins');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async getUserAdmin(id: number): Promise<UserAdmin> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}/user-admins/${id}`,
        {
          headers: getHeaders(),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch user admin');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async createUserAdmin(data: CreateUserAdminRequest): Promise<UserAdmin> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}/user-admins`,
        {
          method: 'POST',
          headers: getHeaders(),
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to create user admin');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async updateUserAdmin(id: number, data: UpdateUserAdminRequest): Promise<void> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}/user-admins/${id}`,
        {
          method: 'PUT',
          headers: getHeaders(),
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to update user admin');
      }
    } catch (error) {
      throw error;
    }
  },

  async deleteUserAdmin(id: number): Promise<void> {
    try {
      const response = await fetch(
        `${API_CONFIG.BASE_URL}/user-admins/${id}`,
        {
          method: 'DELETE',
          headers: getHeaders(),
        }
      );

      if (!response.ok) {
        throw new Error('Failed to delete user admin');
      }
    } catch (error) {
      throw error;
    }
  },
}; 